import { createRoot } from 'react-dom/client';
import { MainPage } from '../pages/MainPage';

createRoot(document.getElementById('root')!).render(<MainPage {...window.__PAGE_PROPS__} />);
